import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const AddedCartIcon: FC<Props> = (props) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-labelledby="titleId"
      {...props}
     aria-label="added cart icon">
      {/* <title>added cart icon</title> */}

      <path
        d="M3.57 8.59736L3.56949 8.59804C3.27872 8.98603 3.15745 9.46224 3.22728 9.94222L3.22734 9.94261L4.30534 17.3871L4.30556 17.3886C4.46766 18.529 5.46154 19.3922 6.61553 19.3922H19.0126C20.2133 19.3922 21.2374 18.4497 21.3362 17.2479L21.3363 17.2469L22.3734 4.89772L22.4112 4.44847L22.8554 4.37172L24.5506 4.07889L24.5512 4.07878C24.7071 4.05203 24.8151 3.90214 24.7879 3.74155C24.7611 3.58971 24.6071 3.47872 24.4485 3.50454L22.0899 3.9122C22.0897 3.91224 22.0895 3.91228 22.0892 3.91232C21.9584 3.93566 21.8592 4.04384 21.8478 4.1767C21.8478 4.17679 21.8478 4.17688 21.8478 4.17697L21.583 7.33445L21.5382 7.86885L21.0019 7.86904C12.9075 7.87196 8.84826 7.87546 6.80248 7.87954C5.77909 7.88158 5.26115 7.88377 4.99425 7.88608C4.85974 7.88725 4.79348 7.88842 4.75964 7.88944C4.75557 7.88957 4.75229 7.88968 4.74969 7.88978C4.27404 7.96285 3.85683 8.21345 3.57 8.59736Z"
        fill="#3064C0"
        stroke="#3064C0"
        strokeWidth="1.16667"
      />
      <path
        d="M20.3527 23.6532C20.3527 23.1832 19.9699 22.8004 19.4999 22.8004C19.0299 22.8004 18.647 23.1832 18.647 23.6532C18.647 24.1247 19.0302 24.5072 19.4999 24.5072C19.9696 24.5072 20.3527 24.1247 20.3527 23.6532Z"
        fill="#3064C0"
        stroke="#3064C0"
        strokeWidth="1.16667"
      />
      <path
        d="M7.49186 23.6532C7.49186 23.1832 7.10903 22.8004 6.63903 22.8004C6.16903 22.8004 5.7862 23.1832 5.7862 23.6532C5.7862 24.1247 6.16934 24.5072 6.63903 24.5072C7.10872 24.5072 7.49186 24.1247 7.49186 23.6532Z"
        fill="#3064C0"
        stroke="#3064C0"
        strokeWidth="1.16667"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.3291 15.5098C12.242 15.5098 12.1549 15.4764 12.0885 15.4101L10.5998 13.9214C10.4667 13.7883 10.4667 13.5732 10.5998 13.4402C10.7328 13.3072 10.9479 13.3072 11.0809 13.4402L12.3291 14.6884L15.3637 11.6537C15.4967 11.5207 15.7118 11.5207 15.8448 11.6537C15.9779 11.7868 15.9779 12.0018 15.8448 12.1349L12.5697 15.4101C12.5033 15.4764 12.4162 15.5098 12.3291 15.5098Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.1871 13.0278C9.82624 13.3887 9.82634 13.9731 10.1871 14.3339V13.0278ZM10.1871 13.0278C10.548 12.667 11.1324 12.667 11.4933 13.0278L12.3289 13.8635L14.951 11.2413C15.3119 10.8805 15.8963 10.8805 16.2571 11.2413C16.618 11.6022 16.618 12.1866 16.2571 12.5475L15.8447 12.135C15.9777 12.0019 15.9777 11.7869 15.8447 11.6538C15.7116 11.5208 15.4966 11.5208 15.3635 11.6538L12.3289 14.6884L11.0808 13.4403C10.9477 13.3072 10.7327 13.3072 10.5996 13.4403C10.4666 13.5733 10.4666 13.7884 10.5996 13.9215L12.0883 15.4101C12.1538 15.4756 12.2394 15.5089 12.3253 15.5098C12.3265 15.5098 12.3277 15.5098 12.3289 15.5098C12.3301 15.5098 12.3313 15.5098 12.3325 15.5098C12.4184 15.5089 12.504 15.4756 12.5695 15.4101L15.8447 12.135L16.2571 12.5475L12.982 15.8226C12.982 15.8226 12.982 15.8226 12.982 15.8226C12.8021 16.0025 12.5648 16.0932 12.3289 16.0932C12.093 16.0932 11.8558 16.0025 11.6759 15.8226C11.6759 15.8226 11.6759 15.8226 11.6759 15.8226L10.1871 14.3339"
        fill="white"
      />
    </svg>
  );
};

export default AddedCartIcon;
